export default __webpack_public_path__ + "static/media/XPENG.55066990.png";